export const GomakeOutlinedFieldClassName = "gomake-outlined-field";
